"use client";

import React, { createContext, useContext } from "react";
import { Libraries, useLoadScript } from "@react-google-maps/api";

const libraries: Libraries = ["places"];

interface GoogleMapsContextType {
  isLoaded: boolean;
  loadError: Error | undefined;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({
  isLoaded: false,
  loadError: undefined,
});

export const useGoogleMaps = () => useContext(GoogleMapsContext);

export function GoogleMapsProvider({ children }: { children: React.ReactNode }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY || "",
    libraries,
  });

  // Log when the script loads (should only happen once)
  React.useEffect(() => {
    if (isLoaded) {
      console.log("[Google Maps API] Global script loaded successfully");
    }
    if (loadError) {
      console.error("[Google Maps API] Global script load error:", loadError);
    }
  }, [isLoaded, loadError]);

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}